import React from 'react';

import { ScreenFilters, ScreenFiltersApply } from 'components/Filters';

import { Screen, withScreen, createScreenRoute } from '@gogame/screens';

import ApplicationsDataTable from './components/ApplicationsDataTable';
import PrimaryFilters from './components/Filters/PrimaryFilters';
import { applicationsLink, applicationsSearchParams } from './navigation';
import { EMPTY_FILTERS } from './schemas';
import screenReducer from './screenReducer';

const id = 1080;
const permission = 90;

const Applications = withScreen({
  name: 'applications',
  searchParams: applicationsSearchParams,
  reducer: screenReducer,
})(() => {
  return (
    <React.Fragment>
      <Screen.Toolbar />
      <Screen.Body>
        <ScreenFilters emptyValues={EMPTY_FILTERS}>
          <PrimaryFilters />
          <ScreenFiltersApply />
        </ScreenFilters>
        <ApplicationsDataTable />
      </Screen.Body>
    </React.Fragment>
  );
});

export default createScreenRoute({
  title: 'Applications',
  link: applicationsLink,
  screen: <Applications />,
  id: id,
  permission: permission,
});
